import axios from 'axios';

const BillPaymentBillLineItemService = {
  async reverseBillPaymentBillLineItem(id) {
    const response = await axios.patch(
      `/bill_payment_bill_line_item/${id}/reverse`
    );

    return response.data;
  },
};

export default BillPaymentBillLineItemService;
